import { format } from "date-fns";
import React from "react";
import { t } from "ttag";

import { ServerCmsTypesVideoCard, VideoPageContentBlock } from "@reactivated";

import { ButtonSecondary, Clickable } from "../Clickables";
import { H, HLevel } from "../Headings";
import { RichText } from "../RichText";
import { Share } from "../Share";
import { Svg } from "../Svg";
import { YoutubeThumbnail } from "../VideoGrid";

import styles from "./index.module.scss";

export const VideoContent = ({
    value,
    ...page
}: {
    value: VideoPageContentBlock;
    title?: string;
    tag?: string;
    last_modified: Date;
    canonical_url: string;
    prev_video: ServerCmsTypesVideoCard | null;
    next_video: ServerCmsTypesVideoCard | null;
}) => (
    <main className={styles.root}>
        <header>
            {page.tag && <p className={styles.eyebrow}>{page.tag}</p>}
            {page.title && <H className={styles.title}>{page.title}</H>}
            <p>
                <span className={styles.updated}>
                    {t`Updated`}{" "}
                    <time dateTime={format(page.last_modified, "yyyy-MM-dd")}>
                        {format(page.last_modified, "MMMM d, yyyy")}
                    </time>
                </span>
                <Share url={page.canonical_url} />
            </p>
        </header>
        {value.left && (
            <RichText
                value={value.left}
                style={{ "--right-rail-count": value.right?.length ?? 0 }}
                className={styles.body}
            />
        )}
        {value.right?.length ? (
            <>
                {value.right.map(({ value, id }) => (
                    <HLevel key={id}>
                        <div className={styles.card}>
                            <H className={styles.cardHeader}>
                                {value.headline}
                            </H>
                            {value.body && <RichText value={value.body} />}
                            {value.cta && (
                                <ButtonSecondary
                                    className={styles.link}
                                    simpleLink={value.cta}
                                />
                            )}
                        </div>
                    </HLevel>
                ))}
            </>
        ) : null}
        {value.show_prev_next && page.prev_video && (
            <Clickable className={styles.prev} href={page.prev_video.url}>
                <span className={styles.text}>
                    <span>{t`Previous`}</span>
                    <span>{page.prev_video.title}</span>
                </span>
                <span className={styles.img}>
                    <Svg aria-hidden name="caret" />
                    <YoutubeThumbnail videoId={page.prev_video.embed_id} />
                </span>
            </Clickable>
        )}
        {value.show_prev_next && page.next_video && (
            <Clickable className={styles.next} href={page.next_video.url}>
                <span className={styles.text}>
                    <span>{t`Up Next`}</span>
                    <span>{page.next_video.title}</span>
                </span>
                <span className={styles.img}>
                    <YoutubeThumbnail videoId={page.next_video.embed_id} />
                    <Svg aria-hidden name="caret" />
                </span>
            </Clickable>
        )}
    </main>
);
